import { useAuthStore } from '../auth/authStore'
import { EmptyState } from '../../shared/ui/EmptyState'
import { RosDashboard } from './RosDashboard'

// Прямой роут /dashboard/ros: для РОЗ дашборд открывается и с главной
// (/dashboard), а этот путь нужен ADMIN и GENERAL_DIRECTOR (read-only),
// у которых на главной свой админский дашборд. Гейт на странице + 403 на API.

export function RosDashboardPage() {
  const role = useAuthStore((s) => s.user?.role)
  const allowed = role === 'ROS' || role === 'ADMIN' || role === 'GENERAL_DIRECTOR'
  if (!allowed) {
    return <EmptyState title="Раздел доступен только РОЗ, администратору и гендиректору" />
  }
  return <RosDashboard />
}
